import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth/auth';

export const superAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toastr = inject(ToastrService);

  if (authService.isSuperAdmin()) {
    return true;
  }

  toastr.warning(
    'You do not have permission to access Admin Users.',
    'Access Denied'
  );

  router.navigate(['/dashboard']);
  return false;
};